import {RowAction, RowActionProps} from './RowAction'

export interface EditRowActionProps<T>
  extends Omit<RowActionProps<T>, 'iconType' | 'iconName' | 'variant' | 'tooltip'> {}

export const EditRowAction = <T,>(props: EditRowActionProps<T>) => {
  return <RowAction iconType='Design' iconName='Edit' variant='warning' tooltip='Edit' {...props} />
}
